var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          route_name: "financial_fees",
          route_grid_path: "/grid",
          order_column: "created_at",
          direction: "desc",
          hide_actions: "true",
          "show-export": true,
          "export-types": ["csv", "xls"],
          "export-filename": "hubee_taxas_plataforma",
          "fetch-on-mounted": false,
          hide_searchbar: "true",
        },
        scopedSlots: _vm._u([
          {
            key: "filterZone",
            fn: function () {
              return [
                _c("FinancialPeriodFilter", {
                  on: { change: _vm.handleFilterChange },
                  model: {
                    value: _vm.filters,
                    callback: function ($$v) {
                      _vm.filters = $$v
                    },
                    expression: "filters",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "gridThead",
            fn: function () {
              return [
                _c("vs-th", { key: "id", attrs: { "sort-key": "id" } }, [
                  _vm._v("ID"),
                ]),
                _c(
                  "vs-th",
                  { key: "order_id", attrs: { "sort-key": "order_id" } },
                  [_vm._v("Pedido")]
                ),
                _c("vs-th", { key: "gross_value" }, [_vm._v("Valor da venda")]),
                _c("vs-th", { key: "fee_percent" }, [_vm._v("Taxa (%)")]),
                _c("vs-th", { key: "fee_value" }, [_vm._v("Taxa (R$)")]),
                _c("vs-th", { key: "net_value" }, [_vm._v("Valor líquido")]),
                _c("vs-th", { key: "source" }, [_vm._v("Origem")]),
                _c(
                  "vs-th",
                  { key: "created_at", attrs: { "sort-key": "created_at" } },
                  [_vm._v("Data")]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "gridData",
            fn: function (props) {
              return _vm._l(props.data, function (tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c("vs-td", { key: "id", attrs: { width: "5%" } }, [
                      _c("div", [_vm._v(_vm._s(tr.id))]),
                    ]),
                    _c("vs-td", { key: "order_id", attrs: { width: "8%" } }, [
                      _c("div", [_vm._v(_vm._s(tr.order_id))]),
                    ]),
                    _c(
                      "vs-td",
                      { key: "gross_value", attrs: { width: "15%" } },
                      [
                        _c("span", { staticClass: "hb-money" }, [
                          _vm._v(_vm._s(_vm.formatCurrency(tr.gross_value))),
                        ]),
                      ]
                    ),
                    _c(
                      "vs-td",
                      { key: "fee_percent", attrs: { width: "10%" } },
                      [
                        _c("div", [
                          _vm._v(_vm._s(_vm.formatPercent(tr.fee_percent))),
                        ]),
                      ]
                    ),
                    _c("vs-td", { key: "fee_value", attrs: { width: "13%" } }, [
                      _c("span", { staticClass: "hb-money" }, [
                        _vm._v(_vm._s(_vm.formatCurrency(tr.fee_value))),
                      ]),
                    ]),
                    _c("vs-td", { key: "net_value", attrs: { width: "15%" } }, [
                      _c("span", { staticClass: "font-semibold hb-money" }, [
                        _vm._v(_vm._s(_vm.formatCurrency(tr.net_value))),
                      ]),
                    ]),
                    _c(
                      "vs-td",
                      { key: "source", attrs: { width: "14%" } },
                      [
                        _c(
                          "vs-chip",
                          {
                            staticClass: "text-base",
                            attrs: {
                              color:
                                tr.source === "PLAN" ? "primary" : "warning",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.getSourceLabel(tr.source)) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "vs-td",
                      { key: "created_at", attrs: { width: "20%" } },
                      [
                        _c("div", [
                          _vm._v(_vm._s(_vm.$utils.format.date(tr.created_at))),
                        ]),
                      ]
                    ),
                  ],
                  1
                )
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }